import '@angular/localize/init';
export * from './lib/feature-tax-vat-details.module';
export * from './lib/vat-details/feature-tax-vat-details.component';
